import { Resizable } from 'react-resizable';
import { useState, SyntheticEvent } from 'react';
import { StyledResizableTitle, StyledResizableHandle } from 'components/styledComponents/table/Table.styled';

type ResizeCallback = (
    e: SyntheticEvent,
    data: { size: { width: number; height: number } }
) => void;

interface ResizeableTitleProps {
  minWidth?: number;
  onResize?: ResizeCallback;
  onResizeStart?: ResizeCallback;
  onResizeStop?: ResizeCallback;
  width?: number;
}

const ResizeableTitle = ({
  onResize, width, onResizeStop, onResizeStart, minWidth = 64, ...restProps
}:ResizeableTitleProps) => {
  const [isResizing, setIsResizing] = useState<boolean>(false);
  if (!width) {
    return <th {...restProps} />;
  }

  const handleResizeStart:ResizeableTitleProps['onResizeStart'] = (e, data) => {
    e.stopPropagation();
    onResizeStart?.(e, data);
    setIsResizing(true);
  };

  const handleResizeStop:ResizeableTitleProps['onResizeStop'] = (e, data) => {
    onResizeStop?.(e, data);
    setTimeout(() => {
      setIsResizing(false);
    }, 0);
  };

  const ResizableHandle = ({ handleAxis: _handleAxis, ...props }: { handleAxis?: string }) => (
    <StyledResizableHandle {...props} className="react-resizable-handle" />
  );

  return (
    <Resizable
      width={width}
      height={0}
      onResizeStop={handleResizeStop}
      onResizeStart={handleResizeStart}
      onResize={onResize}
      minConstraints={[minWidth, 0]}
      maxConstraints={[520, 0]}
      handle={<ResizableHandle />}
      draggableOpts={{ enableUserSelectHack: false }}
      axis="x"
      className={isResizing ? 'ant-table-cell-resizing' : ''}
    >
      <StyledResizableTitle {...restProps} {...(isResizing && { onClick: (e) => e.stopPropagation() })} $isResizing={isResizing} $width={width} />
    </Resizable>
  );
};

export default ResizeableTitle;
